module.exports = __webpack_public_path__ + "assets/img/small_capsule_icon.38300255.svg";